<script lang="ts">
  import type { TGetAssetsResult } from "../../../passport-evm/src/utils/types";
  import ContentHeader from "../shared/ContentHeader.svelte";
  import { resolveIPFS } from "./ipfs";

  export let asset: TGetAssetsResult[number];
  export let onClose: () => void;
</script>

<ContentHeader
  text={asset.metadata?.name ?? ""}
  description={asset.metadata?.description ?? ""}
/>

<button
  class="crtw-text-gray-800 crtw-absolute crtw-top-4 crtw-left-4"
  on:click={onClose}
>
  &larr; Back
</button>

<div
  class="crtx-flex crtw-max-w-full crtw-aspect-square crtw-bg-[#B4A7D6] crtw-rounded-sm crtw-mb-4 crtw-overflow-hidden"
>
  {#if asset.metadata?.image || asset.metadata?.image_url}
    <img
      src={resolveIPFS(asset.metadata?.image || asset.metadata?.image_url)}
      alt="Asset"
      class="crtw-w-full crtw-h-full crtw-object-cover"
    />
  {/if}
</div>

<div class="crtw-space-y-1">
  {#if asset.metadata?.price}
    <p class="crtw-text-xl crtw-font-bold crtw-text-gray-900">
      {asset.metadata?.price}
      <span
        class="crtw-text-[10px] crtw-text-gray-400 crtw-align-top crtw-uppercase"
        >usd</span
      >
    </p>
  {/if}

  {#each Object.entries(asset.metadata ?? {}).filter(([key]) => !["image", "image_url", "price", "name", "description"].includes(key)) as [key, value]}
    <p class="crtw-text-xs crtw-text-gray-500 crtw-leading-tight">
      {key}: {value}
    </p>
  {/each}
</div>

<div class="crtw-mt-[10px]">
  <p class="crtw-text-xs crtw-text-gray-400 crtw-leading-tight">
    Contract: {asset.contractAddress}
  </p>
  <p class="crtw-text-xs crtw-text-gray-400 crtw-leading-tight">
    Token Id: {asset.tokenId}
  </p>
</div>
